export default "__VITE_ASSET__sSWC6SHT__"